/**
 *
 * @param {WindowCoordinatesProps} event
 * @param {"x" | "y"} axis
 * @param {Number} specification
 * @returns {Number}
 */
const getDeltaPercents = (event, axis, specification) => {
  const eventAxis = /** @type {Number} */ (event.get(axis));
  const lastRaf = event.get(`last-raf-${axis}`);

  return (eventAxis - (lastRaf || eventAxis)) / specification;
};

export default getDeltaPercents;